<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Operator</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item">
                    <router-link to="/toolkit/working-hours/list">Working Hours</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operator</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a ref="formBc" class="btn add-btn" @click="showBroadcast(true)" href="#" data-toggle="modal"
                  data-target="#add_form">
                  <i class="fa fa-plus"></i> Tambah
                </a>
              </div>
              <a v-show="false" ref="formBcEdit" class="btn add-btn" @click="showBroadcast(false)" href="#"
                data-toggle="modal" data-target="#add_form">
                <i class="fa fa-pencil"></i> Edit
              </a>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.keywords" type="text"
                  placeholder="Internal Name, Public Name, Phone Number" />
                <label class="focus-label">Keywords</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <select class="form-control" v-model="serverParams.columnFilters.is_publish">
                  <option :value="''">-- Select --</option>
                  <option :value="'publish'">Publish</option>
                  <option :value="'draft'">Draft</option>
                </select>
                <label class="focus-label">Status</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="alert alert-warning">
                Daftar Operator yang akan menerima pesan dari WhatsApp Rotator Anda.
              </div>
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center">Internal Name</th>
                      <th class="text-center">Public Name</th>
                      <th class="text-center">Phone Number</th>
                      <th class="text-center">Role</th>
                      <th class="text-center">Clicks</th>
                      <th class="text-center">Assign To</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">Last Modified</th>
                      <th class="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="5">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td>{{ row.number }}</td>
                        <td>{{ row.internal_name }}</td>
                        <td>{{ row.public_name }}</td>
                        <td>{{ row.phone_number }}</td>
                        <td>{{ row.role_name }}</td>
                        <td class="text-center">
                          <div class="badge badge-warning">{{ row.num_clicks }}</div>
                        </td>
                        <td class="text-center">
                          <div class="badge badge-warning">{{ row.num_assign_to }}</div>
                        </td>

                        <td>
                          <div class="badge badge-warning" v-if="row.is_publish == '0'">
                            <i class="fa fa-save"></i> Draft
                          </div>
                          <div class="badge badge-success" v-else>
                            <i class="fa fa-check"></i> Published
                          </div>
                        </td>
                        <td>{{ formatLocalDateWithDay(convertUTCDatetimeToUnix(row.update_datetime)) }}</td>
                        <td>
                          <div class="dropdown action-label">
                            <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="#" data-toggle="dropdown"
                              aria-expanded="false">
                              <i class="fa fa-dot-circle-o text-danger"></i> Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a v-if="row.is_publish == 1" @click.prevent="draftData(row.id)" class="dropdown-item">
                                <i class="fa fa-save text-warning"></i> Set to Draft
                              </a>
                              <a v-if="row.is_publish == 0" @click.prevent="publishData(row.id)" class="dropdown-item">
                                <i class="fa fa-sign-in text-info"></i> Set to Publish
                              </a>
                              <a @click.prevent="detailData(row.id)" class="dropdown-item">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>
                              <a @click.prevent="deleteData(row.id)" class="dropdown-item">
                                <i class="fa fa-trash-o text-danger"></i> Remove
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' + {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchData" />
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatLocalDateWithDay
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    Multiselect,
    FormData
  },
  data() {
    return {
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          keywords: "",
          is_publish: ""
        },
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  watch: {},
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    formatLocalDateWithDay(unixTime) {
      return formatLocalDateWithDay(unixTime);
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("toolkit/setIsShowForm", false);

      let dataParam = await {};
      dataParam = await {
        id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("toolkit/detailOperator", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;

          formData = data;
        });
      // console.log("formData::", formData);
      // formData.id = id;
      formData.copy = false;
      await this.$store.dispatch("toolkit/actformParamOperatorSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },

    draftData(id) {
      let dataParam = {};
      dataParam = {
        id: id
      };
      this.$store
        .dispatch("toolkit/updateOperatorDraft", dataParam) // sesuai kan dengan method di API
        .then(response => {
          this.searchData();
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
        });
    },
    publishData(id) {
      let dataParam = {};
      dataParam = {
        id: id
      };
      this.$store
        .dispatch("toolkit/updateOperatorPublish", dataParam) // sesuai kan dengan method di API
        .then(response => {
          this.searchData();
          this.$fire({
            title: "Success",
            text: response["msg"],
            type: "success",
            timer: 2000
          });
        });
    },
    deleteData(id) {
      this.$fire({
        title: "Are you sure you will delete this data?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          let dataParam = {};
          dataParam = {
            id: id
          };
          this.$store
            .dispatch("toolkit/deleteOperator", dataParam) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
        }
      });
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("toolkit/setIsShowForm", false);
        this.selectedLicense = [];

        let formData = {
          id: "",
          internal_name: "",
          public_name: "",
          role_name: "",
          phone_number: "",
          greeting_message: "",
          photo: "",
          is_scheduling: 0,
          is_publish: 0,
          wh_sunday_status: 0,
          wh_sunday_start: "08:00",
          wh_sunday_start_hour: "08",
          wh_sunday_start_minute: "00",
          wh_sunday_end: "17:00",
          wh_sunday_end_hour: "17",
          wh_sunday_end_minute: "00",
          wh_monday_status: 0,
          wh_monday_start: "08:00",
          wh_monday_start_hour: "08",
          wh_monday_start_minute: "00",
          wh_monday_end: "17:00",
          wh_monday_end_hour: "17",
          wh_monday_end_minute: "00",
          wh_tuesday_status: 0,
          wh_tuesday_start: "08:00",
          wh_tuesday_start_hour: "08",
          wh_tuesday_start_minute: "00",
          wh_tuesday_end: "17:00",
          wh_tuesday_end_hour: "17",
          wh_tuesday_end_minute: "00",
          wh_wednesday_status: 0,
          wh_wednesday_start: "08:00",
          wh_wednesday_start_hour: "08",
          wh_wednesday_start_minute: "00",
          wh_wednesday_end: "17:00",
          wh_wednesday_end_hour: "17",
          wh_wednesday_end_minute: "00",
          wh_thursday_status: 0,
          wh_thursday_start: "08:00",
          wh_thursday_start_hour: "08",
          wh_thursday_start_minute: "00",
          wh_thursday_end: "17:00",
          wh_thursday_end_hour: "17",
          wh_thursday_end_minute: "00",
          wh_friday_status: 0,
          wh_friday_start: "08:00",
          wh_friday_start_hour: "08",
          wh_friday_start_minute: "00",
          wh_friday_end: "17:00",
          wh_friday_end_hour: "17",
          wh_friday_end_minute: "00",
          wh_saturday_status: 0,
          wh_saturday_start: "08:00",
          wh_saturday_start_hour: "08",
          wh_saturday_start_minute: "00",
          wh_saturday_end: "17:00",
          wh_saturday_end_hour: "17",
          wh_saturday_end_minute: "00"
        };
        this.$store.dispatch("toolkit/actformParamOperatorSt", formData);
      }
      var that = this;
      setTimeout(function () {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("toolkit/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("toolkit/listOperator", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>


// WEBPACK FOOTER //
// src/views/toolkit/operator/list.vue